var _defs, _path, _line, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPinAltSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #336;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 66.7px;\n      }\n\n      .st1 {\n        stroke: #d47500;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190,500c-55.5,21.2-90,50.7-90,83.3,0,64.4,134.3,116.7,300,116.7s300-52.2,300-116.7-34.5-62.1-90-83.3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 400,
    y1: 300,
    x2: 400.3,
    y2: 300
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M600,300c0,135.5-150,200-200,300-50-100-200-164.5-200-300s89.5-200,200-200,200,89.5,200,200Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 400,
    cy: 300,
    r: 33.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinAltSvgrepoCom);
export default __webpack_public_path__ + "static/media/map-pin-alt-svgrepo-com.40f22062bfc7ebed58f3c1011cc88202.svg";
export { ForwardRef as ReactComponent };